<script>
import Card from './Card';

export default {

    name: 'CardImgOverlay',

    extends: Card

};
</script>
